function initEmailStatusModal() {
  document.addEventListener('DOMContentLoaded', () => {
    const statusModal = document.getElementById(
      'statusModal',
    ) as HTMLElement | null
    if (!statusModal) {
      console.warn('Could not find the statusModal')
      return
    }
    const modalBody = statusModal?.querySelector('.modal-body tbody')
    if (!modalBody) {
      console.warn('Could not find the table body in statusModal')
      return
    }
    document
      .querySelectorAll('[data-bs-target="#statusModal"]')
      .forEach((button) => {
        button.addEventListener('click', async (event) => {
          const dataItem = (event.currentTarget as HTMLElement).dataset
            .itemMessageId
          if (!dataItem) {
            return
          }
          try {
            const response = await fetch(`/partner/email/${dataItem}/logs`, {
              headers: {
                'Content-Type': 'application/json',
              },
              method: 'GET',
            })
            if (!response.ok) throw new Error('Fetch failed')
            const data = await response.json()
            modalBody!.innerHTML =
              data.esp_events.length === 0
                ? `
              <tr>
                <td colspan="3" class="text-center text-muted">
                  <i class="bi bi-info-circle me-2"></i> No logs available.
                </td>
              </tr>
            `
                : data.esp_events
                    .map(
                      (item: {
                        timestamp: string
                        email_to: string
                        status: string
                      }) => `
                <tr>
                  <td>${item.timestamp}</td>
                  <td>${item.email_to}</td>
                  <td>${item.status}</td>
                </tr>
              `,
                    )
                    .join('')
          } catch (error) {
            console.error(error)
            modalBody!.innerHTML = `
              <tr>
                <td colspan="3" class="text-danger text-center">
                  <i class="bi bi-exclamation-triangle-fill me-2"></i> Failed to load logs.
                </td>
              </tr>
            `
          }
        })
      })
  })
}

export { initEmailStatusModal }
